import React from 'react';
import { useTranslation } from 'react-i18next';
import '../style.css';

const Tahapan = () => {
  const { t } = useTranslation();

  const benefits = [
    { icon: 'fa-graduation-cap', copy: t('benefit.first') },
    { icon: 'fa-book-open', copy: t('benefit.second') },
    { icon: 'fa-people-group', copy: t('benefit.third') },
    { icon: 'fa-earth-asia', copy: t('benefit.four') },
  ];

  const requirements = [
    { icon: 'fa-user', copy: t('requirement.first') },
    { icon: 'fa-file-lines', copy: t('requirement.second') },
    { icon: 'fa-calendar-check', copy: t('requirement.four') },
    { icon: 'fa-gift', copy: t('requirement.five') },
  ];

  const timeline = [
    { icon: 'fa-pen-nib', title: t('step.first'), date: t('step.first_date') },
    { icon: 'fa-flag-checkered', title: t('step.four'), date: t('step.four_date') },
    { icon: 'fa-trophy', title: t('step.five'), date: t('step.five_date') },
    { icon: 'fa-calendar-day', title: t('step.six'), date: t('step.six_date') },
  ];

  return (
    <>
      <section className="details-section" aria-label={t('details.label')}>
        <div className="container details-grid">
          <article className="detail-column" id="benefit">
            <h2>{t('benefit.title')}</h2>
            <div className="detail-list">
              {benefits.map((item) => (
                <div className="detail-item" key={item.copy}>
                  <span className="detail-item__icon">
                    <i className={`fa-solid ${item.icon}`} aria-hidden="true" />
                  </span>
                  <p>{item.copy}</p>
                </div>
              ))}
            </div>
          </article>

          <article className="detail-column" id="persyaratan">
            <h2>{t('requirement.title')}</h2>
            <div className="detail-list">
              {requirements.map((item) => (
                <div className="detail-item" key={item.copy}>
                  <span className="detail-item__icon">
                    <i className={`fa-solid ${item.icon}`} aria-hidden="true" />
                  </span>
                  <p>{item.copy}</p>
                </div>
              ))}
            </div>
          </article>
        </div>

        <a className="section-cta" href="#header">{t('requirement.button_register')}</a>
      </section>

      <section id="tahapan" className="timeline-section" aria-labelledby="timeline-title">
        <div className="container">
          <div className="section-heading">
            <p>{t('step.eyebrow')}</p>
            <h2 id="timeline-title">{t('step.title')}</h2>
          </div>

          <ol className="timeline-list">
            {timeline.map((item) => (
              <li className="timeline-item" key={item.date}>
                <span className="timeline-item__icon">
                  <i className={`fa-solid ${item.icon}`} aria-hidden="true" />
                </span>
                <time>{item.date}</time>
                <p>{item.title}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </>
  );
};

export default Tahapan;
